import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { Address } from "../models/base";
import { Project } from "../models/project";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// export function AddressToString(address: Address) {
//   //let state = stateList[address.state]
//   return `${address.number} ${address.street}, ${address.city},
//    ${address.state}, ${address.zip}`;
// }

export const convertDataToString = (data: Project): Project => {
  return {
    ...data,
    number: String(data.number || ''), 
    address: data.address ? {...data.address} : null,
  };
};